module.exports = "pegasus_template/assets/preview-4.png";